<div *ngIf="hasOpened">
    <div class="fullscreen-overlay modal d-block" *ngIf="open && ready">
        <div class="modal-backdrop show"></div>
    </div>
    <div class="dashboard-filter-slideout" [class.d-flex]="open && ready" [@visibility]="open && ready ? 'shown' : 'hidden'" style="z-index: 1511">
        <div class="settings-slideout-header p-3 d-flex">
            <div class="subtitle-1 ml-1"><span cvLocalizedText langSection="Dashboard_Tab" langKey="Dashboard_Filter">Dashboard Filter</span></div>
            <button type="button" class="icon-btn fill-gray5-w-hover mr-1 ml-auto" (click)="close()">
                <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
            </button>
        </div>
    
        <p class="px-3 m-0 ml-1 color-whaleTail">
            <span cvLocalizedText langSection="Master_Filter" langKey="Description">The dashboard filter allows you to apply these filters to all of your current modules.</span>
        </p>

        <div class="flex-fill position-relative" [hidden]="ready && settingsManager">
            <cv-loader class="d-block" [overlay]="true"></cv-loader>
        </div>

        <div class="settings-slideout-body overflow-auto flex-fill p-3" *ngIf="ready && settingsManager">
            <div id="masterFilterDatetime" class="card settings-hover-colors d-flex flex-row p-2 my-2" (click)="dateExpanded = !dateExpanded">
                <div class="card-left">
                    <div class="font-size-16 lato-bold" cvLocalizedText langSection="Slideout_Settings" langKey="Date_And_Time_Ampersand">Date &amp; Time</div>
                    <div class="body-2 mt-1">{{ settingsManager.selectedDateRange?.displayNameOrCustomDates }}</div>
                </div>
                <div class="card-right ml-auto d-flex">
                    <div class="my-auto" [hidden]="dateExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
                    <div class="my-auto" [hidden]="!dateExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
                </div>
            </div>
        
            <div class="date-body py-2 mx-3" [ngbCollapse]="!dateExpanded">
                <div class="mb-2 font-size-12"  style="display: inline-block;" cvLocalizedText langSection="Slideout_Settings" langKey="Date_Range">Date Range</div>
                <span class="font-size-12"> - {{ settingsManager.selectedDateRange?.displayName }}</span>

                <cv-date-range-selector *ngIf="settingsManager.availableDateRanges !== null"
                    class="d-block mb-3"
                    [pageName]="dashboardKey + '_temp'" 
                    [settingsManager]="settingsManager"
                    [(selectedDateRange)]="settingsManager.selectedDateRange"
                    [availableDateRanges]="settingsManager.availableDateRanges"
                ></cv-date-range-selector>
        
                <div class="mb-2 font-size-12" cvLocalizedText langSection="Slideout_Settings" langKey="Days_Of_The_Week">Days of the Week</div>
                <cv-dow-selector
                    class="d-block mb-3"
                    [pageName]="dashboardKey + '_temp'" 
                    [(selectedDaysOfWeek)]="settingsManager.selectedDaysOfWeek"
                ></cv-dow-selector>
        
                <cv-time-range-selector *ngIf="dateExpanded"
                    [stateKey]="dashboardKey + '_temp'" 
                    [settingsManager]="settingsManager"
                ></cv-time-range-selector>

                <button type="button" id="masterFilterApplyDatetime" class="btn btn-secondary d-block mx-auto mt-5 mb-4" style="min-height: 30px; max-height: 54px; height: unset;" (click)="applyDateTime()" [disabled]="isApplying">
                    <span *ngIf="!applyingDates" cvLocalizedText langSection="Master_Filter" langKey="Apply_DateTime">Apply Date &amp; Time to All Modules</span>
                    <span *ngIf="applyingDates" cvLocalizedText langSection="Master_Filter" langKey="Applying">Applying to All Modules</span>
                </button>
            </div>

            <div id="masterFilterInterval" class="card settings-hover-colors d-flex flex-row p-2 my-2" (click)="intervalExpanded = !intervalExpanded">
                <div class="card-left">
                    <div class="font-size-16 lato-bold">
                        <span cvLocalizedText langSection="Controls" langKey="Interval_Title">Interval</span>
                    </div>
                    <div class="body-2 mt-1">
                        {{ settingsManager.intervalAmt }}
                        <span cvLocalizedText langSection="Common" langKey="per">per</span>
                        {{ intervalTypes[settingsManager.intervalType] }}
                    </div>
                </div>
                <div class="card-right ml-auto d-flex">
                    <div class="my-auto" [hidden]="intervalExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
                    <div class="my-auto" [hidden]="!intervalExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
                </div>
            </div>

            <div class="date-body py-2 mx-3" [ngbCollapse]="!intervalExpanded">
                <cv-interval-selector
                    class="row mb-3 justify-content-between"
                    [settingsManager]="settingsManager"
                    [stateKey]="dashboardKey + '_temp'"
                    [showFifteenMinute]="settingsManager.fifteenMinutesIntervalVisible"
                ></cv-interval-selector>

                <button type="button" id="masterFilterApplyInterval" class="btn btn-secondary d-block mx-auto mt-5 mb-4" (click)="applyInterval()" [disabled]="isApplying">
                    <span *ngIf="!applyingInterval" cvLocalizedText langSection="Master_Filter" langKey="Apply_Interval">Apply Interval to All Modules</span>
                    <span *ngIf="applyingInterval" cvLocalizedText langSection="Master_Filter" langKey="Applying">Applying to All Modules</span>
                </button>
            </div>

            <div id="masterFilterGroup" class="card settings-hover-colors d-flex flex-row p-2 my-2" (click)="groupsExpanded = !groupsExpanded">
                <div class="card-left">
                    <div class="font-size-16 lato-bold">
                        <span cvLocalizedText langSection="Master_Filter" langKey="Group_Title">Employee & Contact Groups</span>
                    </div>
                    <div class="body-2 mt-1">
                        <ng-container *ngIf="settingsManager.selectedToggle === 0 || settingsManager.selectedToggle === 1">
                            <svg class="icon-16 view-icon-fill"><use href="../App_Themes/clearview-default/icons/utility/view.svg#view"></use></svg>
                            <span cvLocalizedText langSection="AZ_Modules" langKey="View_By">View by</span>
                            {{ settingsManager.selectedLevelName }}
                        </ng-container>
                        <span *ngIf="settingsManager.selectedToggle !== 0 && settingsManager.selectedToggle !== 1">
                            {{ settingsManager.empFilterLevelName }} / {{ settingsManager.recFilterLevelName }}
                        </span>
                    </div>
                </div>
                <div class="card-right ml-auto d-flex">
                    <div class="my-auto" [hidden]="groupsExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
                    <div class="my-auto" [hidden]="!groupsExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
                </div>
            </div>

            <div class="emp-body py-2" [ngbCollapse]="!groupsExpanded">
                <cv-group-selector 
                    [pageName]="dashboardKey + '_temp'" 
                    [baseGroupType]="0"
                    [showSelectedToggle]="true"
                    [hasSelectedToggle]="settingsManager.selectedToggle === 0"
                    (selectedLevelChanged)="settingsManager.onSelectedLevelChanged($event)"
                    [settingsManager]="settingsManager"
                    [selectedGroupsDto]="settingsManager.empSelectorDTO"
                    (selectedGroupsChanged)="settingsManager.onEmpGroupsChanged($event)"
                    [hasMultiSelect]="true"
                ></cv-group-selector>
                <h2 class="font-size-16 lato-bold mt-4">
                    <span cvLocalizedText langSection="Master_Filter" langKey="Contact_Groups">Contact Groups</span>
                </h2>
                <cv-group-selector 
                    [pageName]="dashboardKey + '_temp'" 
                    [baseGroupType]="1"
                    [showSelectedToggle]="true"
                    [hasSelectedToggle]="settingsManager.selectedToggle === 1"
                    (selectedLevelChanged)="settingsManager.onSelectedLevelChanged($event)"
                    [settingsManager]="settingsManager"
                    [selectedGroupsDto]="settingsManager.recSelectorDTO"
                    (selectedGroupsChanged)="settingsManager.onRecGroupsChanged($event)"
                    [hasMultiSelect]="true"
                ></cv-group-selector>

                <button type="button" id="masterFilterApplyGroup" class="btn btn-secondary d-block mx-auto mt-5 mb-4" (click)="applyGroups()" [disabled]="isApplying">
                    <span *ngIf="!applyingGroups" cvLocalizedText langSection="Master_Filter" langKey="Apply_Group">Apply Group to All Modules</span>
                    <span *ngIf="applyingGroups" cvLocalizedText langSection="Master_Filter" langKey="Applying">Applying to All Modules</span>
                </button>
            </div>

            <div id="masterFilterAttribute" class="card settings-hover-colors d-flex flex-row p-2 my-2 bg-greekToMe" (click)="attrExpanded = !attrExpanded">
                <div class="card-left">
                    <div class="font-size-16 lato-bold">
                        <span cvLocalizedText langSection="Common" langKey="Attributes">Attributes</span>
                    </div>
                    <div class="body-2 mt-1">
                        <ng-container *ngIf="settingsManager.selectedToggle === 2 || settingsManager.selectedToggle === 3">
                            <svg class="icon-16 view-icon-fill"><use href="../App_Themes/clearview-default/icons/utility/view.svg#view"></use></svg>
                            <span cvLocalizedText langSection="AZ_Modules" langKey="View_By">View by</span>
                        </ng-container>
                        {{ settingsManager.attributesText }}
                    </div>
                </div>
                <div class="card-right ml-auto d-flex">
                    <div class="my-auto" [hidden]="attrExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg></div>
                    <div class="my-auto" [hidden]="!attrExpanded"><svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down"></use></svg></div>
                </div>
            </div>

            <div class="att-body py-2" [ngbCollapse]="!attrExpanded">
                <cv-attribute-selector
                    [hidden]="inUserCatView"
                    [pageName]="dashboardKey + '_temp'"
                    [attributeType]="0"
                    [showSelectedToggle]="true"
                    (categoryViewChanged)="inDataCatView = $event"
                    (selectedLevelChanged)="settingsManager.onSelectedLevelChanged($event)"
                    (selectedAttributesChanged)="settingsManager.onSelectedAttributesChanged($event)"
                    [settingsManager]="settingsManager"
                ></cv-attribute-selector>
                <cv-attribute-selector
                    [hidden]="inDataCatView"
                    [pageName]="dashboardKey + '_temp'"
                    [attributeType]="1"
                    [showSelectedToggle]="true"
                    (categoryViewChanged)="inUserCatView = $event"
                    (selectedLevelChanged)="settingsManager.onSelectedLevelChanged($event)"
                    (selectedAttributesChanged)="settingsManager.onSelectedAttributesChanged($event)"
                    [settingsManager]="settingsManager"
                ></cv-attribute-selector>

                <button type="button" id="masterFilterApplyAttribute" class="btn btn-secondary d-block mx-auto mt-5 mb-4" (click)="applyAttributes()" [disabled]="isApplying">
                    <span *ngIf="!applyingAttrs" cvLocalizedText langSection="Master_Filter" langKey="Apply_Attribute">Apply Attribute to All Modules</span>
                    <span *ngIf="applyingAttrs" cvLocalizedText langSection="Master_Filter" langKey="Applying">Applying to All Modules</span>
                </button>
            </div>
        </div>

        <div class="d-flex w-100" *ngIf="showToast">
            <ngb-toast id="dashboard-filter-modules-toast"
                class="mx-auto my-3 w-100"
                [ngClass]="toastIsError ? 'bg-danger text-light' : 'bg-whaleTail color-white'"
                (hidden)="closeToast()"
                [autohide]="true"
                [delay]="5000"
            >
                <div class="d-flex">
                    <div class="lato-bold" cvLocalizedText langSection="Master_Filter" langKey="Dashboard_Filter_Changed" *ngIf="!toastIsError">Dashboard Filter has been changed.</div>
                    <div class="lato-bold" *ngIf="toastIsError">Error applying module settings!</div>
                    <svg class="icon-16 fill-valyrianSteel clickable ml-auto my-auto" (click)="closeToast()"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
                </div>
            </ngb-toast>
        </div>
    </div>
</div>
